export default function FounderGuarantee() {
  return (
    <section
      data-testid="founder-guarantee-section"
      id="guarantee"
      className="bg-white py-14 md:py-20 border-t border-[#E5EBF2]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#0E2A57]/60 font-medium">
          03 — Our Personal Guarantee
        </span>
        <blockquote
          data-testid="founder-quote"
          className="mt-6 italic-display text-2xl md:text-[2rem] leading-[1.35] text-[#050B14]"
        >
          <span className="text-[#2BB6E5] mr-1">“</span>
          As a family-owned business, our reputation is on the line with every
          contract. We do not hide behind a corporate logo. We personally
          guarantee that our team will treat your workplace with the highest
          level of respect, integrity, and precision. If anything is ever less
          than perfect, we fix it immediately. That is our family promise to
          Irish businesses.
          <span className="text-[#2BB6E5] ml-1">”</span>
        </blockquote>
        <div className="mt-6 inline-flex items-center gap-3">
          <span className="h-px w-8 bg-[#0E2A57]" />
          <div className="text-left">
            <div className="font-heading font-bold text-sm text-[#0E2A57]">
              Gazi
            </div>
            <div className="text-xs text-[#737373]">
              Founder & Managing Director
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
